import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

interface JoinWaitlistRequest {
  email: string;
}

export interface JoinWaitlistResponse {
  message: string;
}

export const waitlistApi = createApi({
  reducerPath: 'waitlistApi',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    joinWaitlist: builder.mutation<JoinWaitlistResponse, JoinWaitlistRequest>({
      query: (body) => ({
        url: '/waitlist/join',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useJoinWaitlistMutation } = waitlistApi;
